import React from 'react'

const TeamsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='27'
    height='25'
    viewBox='0 0 27 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_13499_18035)'>
      <path
        d='M18.6356 9.53516H25.3514C25.9859 9.53516 26.5003 10.0473 26.5003 10.679V16.77C26.5003 19.0919 24.6099 20.9741 22.278 20.9741H22.258C19.9261 20.9744 18.0355 19.0924 18.0352 16.7706C18.0352 16.7704 18.0352 16.7702 18.0352 16.77V10.133C18.0352 9.80281 18.304 9.53516 18.6356 9.53516Z'
        fill='#5059C9'
      />
      <path
        d='M23.1741 8.32665C24.6768 8.32665 25.895 7.11369 25.895 5.61743C25.895 4.12116 24.6768 2.9082 23.1741 2.9082C21.6713 2.9082 20.4531 4.12116 20.4531 5.61743C20.4531 7.11369 21.6713 8.32665 23.1741 8.32665Z'
        fill='#5059C9'
      />
      <path
        d='M14.7076 8.33153C16.8782 8.33153 18.6378 6.57948 18.6378 4.41821C18.6378 2.25694 16.8782 0.504883 14.7076 0.504883C12.537 0.504883 10.7773 2.25694 10.7773 4.41821C10.7773 6.57948 12.537 8.33153 14.7076 8.33153Z'
        fill='#7B83EB'
      />
      <path
        d='M19.9576 9.53516H8.87192C8.24499 9.5506 7.74905 10.0686 7.7636 10.6929V17.64C7.67605 21.386 10.6526 24.4947 14.4148 24.5864C18.1769 24.4947 21.1535 21.386 21.0659 17.64V10.6929C21.0805 10.0686 20.5845 9.5506 19.9576 9.53516Z'
        fill='#7B83EB'
      />
      <path
        opacity='0.1'
        d='M15.0179 9.53516V19.2703C15.0149 19.7167 14.7432 20.1178 14.3286 20.2878C14.1966 20.3434 14.0547 20.372 13.9113 20.372H8.29413C8.21553 20.1734 8.14297 19.9747 8.0825 19.77C7.87084 19.0792 7.76285 18.361 7.76203 17.6387V10.6911C7.7475 10.0678 8.24262 9.5506 8.86854 9.53516H15.0179Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M14.4132 9.53516V19.8723C14.4132 20.0151 14.3844 20.1563 14.3286 20.2878C14.1578 20.7006 13.7551 20.9711 13.3067 20.9741H8.57832C8.47553 20.7754 8.37879 20.5767 8.29413 20.372C8.20948 20.1674 8.14297 19.9747 8.0825 19.77C7.87084 19.0792 7.76285 18.361 7.76203 17.6387V10.6911C7.7475 10.0678 8.24262 9.5506 8.86854 9.53516H14.4132Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M14.4132 9.53516V18.6682C14.4086 19.2748 13.9159 19.7654 13.3067 19.77H8.0825C7.87084 19.0792 7.76285 18.361 7.76203 17.6387V10.6911C7.7475 10.0678 8.24262 9.5506 8.86854 9.53516H14.4132Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M13.8085 9.53516V18.6682C13.8039 19.2748 13.3112 19.7654 12.702 19.77H8.0825C7.87084 19.0792 7.76285 18.361 7.76203 17.6387V10.6911C7.7475 10.0678 8.24262 9.5506 8.86854 9.53516H13.8085Z'
        fill='black'
      />
      <path
        opacity='0.1'
        d='M15.0104 6.41912V8.31558C14.9077 8.32159 14.8109 8.32762 14.7081 8.32762C14.6053 8.32762 14.5086 8.3216 14.4058 8.31558C14.2017 8.30209 13.9993 8.26985 13.8011 8.21925C12.5767 7.93054 11.5651 7.07553 11.0802 5.91943C10.9968 5.72528 10.932 5.52369 10.8867 5.31738H13.9039C14.5141 5.31968 15.0081 5.81159 15.0104 6.41912Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M14.3998 7.02166V8.31607C14.1957 8.30259 13.9933 8.27034 13.7951 8.21975C12.5707 7.93103 11.5592 7.07602 11.0742 5.91992H13.2933C13.9034 5.92222 14.3975 6.41414 14.3998 7.02166Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M14.3998 7.02166V8.31607C14.1957 8.30259 13.9933 8.27034 13.7951 8.21975C12.5707 7.93103 11.5592 7.07602 11.0742 5.91992H13.2933C13.9034 5.92222 14.3975 6.41414 14.3998 7.02166Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M13.7951 7.02167V8.21975C12.5707 7.93103 11.5592 7.07602 11.0742 5.91992H12.6886C13.2988 5.92223 13.7928 6.41416 13.7951 7.02167Z'
        fill='black'
      />
      <path
        d='M1.60832 5.91992H12.694C13.3061 5.91992 13.8023 6.41401 13.8023 7.02347V18.0614C13.8023 18.6709 13.3061 19.165 12.694 19.165H1.60832C0.996207 19.165 0.5 18.6709 0.5 18.0614V7.02347C0.5 6.41401 0.996218 5.91992 1.60832 5.91992Z'
        fill='url(#paint0_linear_13499_18035)'
      />
      <path
        d='M10.0759 10.1187H7.85981V16.1271H6.44796V10.1187H4.24219V8.95312H10.0759V10.1187Z'
        fill='white'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_13499_18035'
        x1='2.81088'
        y1='5.05762'
        x2='11.4354'
        y2='20.0595'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#5A62C3' />
        <stop offset='0.5' stopColor='#4D55BD' />
        <stop offset='1' stopColor='#3940AB' />
      </linearGradient>
      <clipPath id='clip0_13499_18035'>
        <rect
          width='26'
          height='24.082'
          fill='white'
          transform='translate(0.5 0.504883)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default TeamsIcon
